interface IconProps {
  fillColor: string
}

export const AndroidPadlockErrorIcon = ({ fillColor }: IconProps) => {
  return (
    <div className="illustration__icon-wrapper">
      <svg
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M40 48.5596C42.2091 48.5596 44 50.3504 44 52.5596C43.9999 54.7686 42.2091 56.5596 40 56.5596C37.7909 56.5596 36.0001 54.7686 36 52.5596C36 50.3504 37.7909 48.5596 40 48.5596ZM40 50.8262C39.0427 50.8262 38.2666 51.6023 38.2666 52.5596C38.2667 53.5168 39.0428 54.293 40 54.293C40.9572 54.293 41.7333 53.5168 41.7334 52.5596C41.7334 51.6023 40.9573 50.8262 40 50.8262Z"
          fill={fillColor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M40 11.4258C47.2533 11.4258 53.1338 17.3062 53.1338 24.5596V35.2256H53.333C57.7511 35.2256 61.3328 38.8075 61.333 43.2256V60.5596C61.3329 64.9777 57.7512 68.5596 53.333 68.5596H26.667C22.2488 68.5596 18.6671 64.9777 18.667 60.5596V43.2256C18.6672 38.8075 22.2489 35.2256 26.667 35.2256H26.8672V24.5596C26.8672 17.3062 32.7467 11.4258 40 11.4258ZM26.667 37.4932C23.6576 37.4932 21.1915 39.8115 20.9541 42.7598H41.333C41.9589 42.7598 42.4667 43.2667 42.4668 43.8926C42.4668 44.5185 41.9589 45.0264 41.333 45.0264H20.9336V60.5596C20.9337 63.7259 23.5006 66.293 26.667 66.293H53.333C55.8704 66.293 58.0213 64.6437 58.7764 62.3594H38.667C38.0411 62.3594 37.5332 61.8515 37.5332 61.2256C37.5334 60.5999 38.0412 60.0928 38.667 60.0928H59.0664V43.2256C59.0662 40.0593 56.4993 37.4932 53.333 37.4932H26.667ZM40 13.6924C33.9985 13.6924 29.1338 18.5581 29.1338 24.5596V35.2256H32.2002V24.5596C32.2002 20.2518 35.6922 16.7598 40 16.7598C44.3078 16.7598 47.7998 20.2517 47.7998 24.5596V35.2256H50.8662V24.5596C50.8662 18.5581 46.0015 13.6924 40 13.6924ZM40 19.0264C36.944 19.0264 34.4668 21.5036 34.4668 24.5596V35.2256H45.5332V24.5596C45.5332 21.5036 43.056 19.0264 40 19.0264Z"
          fill={fillColor}
        />
      </svg>
    </div>
  )
}
